// src/hooks/useDebounce.ts
/**
 * Simple debounce hook — returns a debounced copy of `value`.
 * The returned value only updates after `delay` ms of silence.
 */
import { useEffect, useState } from "react";

export function useDebounce<T>(value: T, delay: number = 300): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
}
